const apiUrls = require('../../constants/apiUrls');

const billingDetails = {
    key: 'billingDetails',
    method: 'GET',
    getApiUrl: (request) => {
        return `${apiUrls.WORKORDER_CUSTOMER_BILLING_URL}?billingSystem=${request.billingSystem}&accountNumber=${request.accountNumber}&marketId=${request.marketId}`;
    },
    dependencies: [
        {
            key: 'orderDetails',
            requestProps: [
                {
                    path: [
                        'details', 'accountNumber'
                    ],
                    propName: 'accountNumber'
                }
            ]
        }, {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'billingSystem'
                    ],
                    propName: 'billingSystem'
                }, {
                    path: [
                        'details', 'marketId'
                    ],
                    propName: 'marketId'
                }
            ]
        }
    ]
};

export default billingDetails;


// WEBPACK FOOTER //
// ./src/store/order-details-config/billingDetails.js